'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../../../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Translate = require('../../../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentResult = function PaymentResult(_ref) {
  var success = _ref.success,
      children = _ref.children,
      onClose = _ref.onClose;

  var title = success ? 'Success' : 'Failed';
  var containerClassName = success ? 'success' : 'failed';
  var iconClassName = success ? 'check' : 'times';

  return _react2.default.createElement(
    'div',
    { className: 'payment-result-wrapper ' + containerClassName },
    _react2.default.createElement(_Icon2.default, { icon: '' + iconClassName }),
    _react2.default.createElement(
      'div',
      { className: 'payment-result-title' },
      title
    ),
    children,
    _react2.default.createElement(
      'button',
      {
        className: 'button ' + (success ? 'secondary' : 'tertiary'),
        onClick: onClose },
      _react2.default.createElement(_Translate2.default, {
        defaultMessage: 'payment.result.close_button',
        id: 'payment.result.close_button'
      })
    )
  );
};

exports.default = PaymentResult;